<div class="competitions-container">
  @if ($loading | async) {
    <div class="shimmer-wrapper">
      <div class="section">
        <app-shimmer-loader height="24px" width="120px" borderRadius="4px" class="section-title-shimmer"></app-shimmer-loader>
        <div class="league-list">
          @for (i of [1,2,3]; track i) {
            <app-shimmer-loader height="36px" width="100%" borderRadius="4px" class="shimmer-item"></app-shimmer-loader>
          }
        </div>
      </div>
      <div class="section">
        <app-shimmer-loader height="24px" width="100px" borderRadius="4px" class="section-title-shimmer"></app-shimmer-loader>
        <div class="accordion-container">
          @for (i of [1,2,3]; track i) {
            <div class="group-shimmer">
              <app-shimmer-loader height="24px" width="100%" borderRadius="4px" class="group-header-shimmer"></app-shimmer-loader>
              <div class="league-list">
                @for (j of [1,2,3]; track j) {
                  <app-shimmer-loader height="32px" width="100%" borderRadius="4px" class="shimmer-item"></app-shimmer-loader>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    @if (popularLeagues.length > 0) {
      <div class="section">
        <div class="section-title">{{ "Popular Leagues" | translate }}</div>
        <div class="league-list">
          @for (league of popularLeagues; track league.id) {
            <a [routerLink]="['/app/main', { outlets: { content: [currentSport, 'league', league.id, league.name] } }]"
               class="league-item">
              {{ league.name }}
            </a>
          }
        </div>
      </div>
    }

    <div class="section">
      <div class="section-title">{{ "All Leagues" | translate }}</div>
      <div class="accordion-container">
        @for (group of allLeagues; track group.letter) {
          <details class="accordion-panel" open>
            <summary class="panel-header">
              <span class="panel-title">{{ group.letter }}</span>
              <span class="indicator"></span>
            </summary>
            <div class="league-list">
              @for (league of group.leagues; track league.id) {
                <a [routerLink]="['/app/main', { outlets: { content: [currentSport, 'league', league.id, league.name] } }]"
                   class="league-item">
                  {{ league.name }}
                </a>
              }
            </div>
          </details>
        }
      </div>
    </div>
  }
</div>
